import { render } from "./payroll-deduction-modal.vue?vue&type=template&id=afc640f4"
import script from "./payroll-deduction-modal.vue?vue&type=script&lang=js"
export * from "./payroll-deduction-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__